/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intakewaittooltip2Inputs */

const en_intakewaittooltip2 = /** @type {(inputs: Intakewaittooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait for the AI to finish reading your files.`)
};

const pt_intakewaittooltip2 = /** @type {(inputs: Intakewaittooltip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espere que a IA termine a leitura dos ficheiros.`)
};

/**
* | output |
* | --- |
* | "Wait for the AI to finish reading your files." |
*
* @param {Intakewaittooltip2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakewaittooltip2 = /** @type {((inputs?: Intakewaittooltip2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakewaittooltip2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakewaittooltip2(inputs)
	return pt_intakewaittooltip2(inputs)
});
export { intakewaittooltip2 as "intakeWaitTooltip" }